module.exports = __webpack_public_path__ + "static/media/innovators.b9de8be8.jpg";